import { createSelector } from 'reselect';

export const getQuestionState = (state: any) =>
  state.getIn(['question', 'questionSecret']);
const getIsLoadingQuestion = (state: any) =>
  state.getIn(['question', 'isLoadingQuestion']);
const getPasswordCurrentRecoveryStepName = (state: any) =>
  state.getIn(['question', 'currentPasswordRecoveryStepName']);

const getIsLoadingPassCov = (state: any) =>
  state.getIn(['question', 'isLoadingPassRecov']);

const getLoginCurrentRecoveryStepName = (state: any) =>
  state.getIn(['question', 'currentLoginRecoveryStepName']);

const getIsLoadingLoginRecovery = (state: any) =>
  state.getIn(['question', 'isLoadingLoginRecovery']);
const getIsLoadingChangePassword = (state: any) =>
  state.getIn(['question', 'isLoadingChangePassword']);
const getIsLoadingChangeSecretQuestion = (state: any) =>
  state.getIn(['question', 'isLoadingChangeSecretQuestion']);
const getIsLoadingNotficationEnabled = (state: any) =>
  state.getIn(['question', 'isLoadingNotficationEnabled']);

const getHashedEmail = (state: any) => state.getIn(['question', 'hashedEmail']);
const getHashedPhone = (state: any) => state.getIn(['question', 'hashedPhone']);
const getToken = (state: any) => state.getIn(['question', 'token']);
const getLogin = (state: any) => state.getIn(['user', 'login']);
const getIsQuestion = (state: any) => state.getIn(['question', 'isQuestion']);
const getIsEmail = (state: any) => state.getIn(['question', 'isEmail']);
const getIsPhone = (state: any) => state.getIn(['question', 'isPhone']);
const getErrorMessage = (state: any) =>
  state.getIn(['question', 'errorMessage']);
const getErrorMessageLogin = (state: any) =>
  state.getIn(['question', 'errorMessageLoginRecovery']);
const getHashedEmailSelector = createSelector(
  getHashedEmail,
  (hashedEmail) => hashedEmail,
);
const getHashedPhoneSelector = createSelector(
  getHashedPhone,
  (hashedPhone) => hashedPhone,
);

const getErrorMessageSelector = createSelector(
  getErrorMessage,
  (errorMessage) => errorMessage,
);

const getIsQuestionSelector = createSelector(
  getIsQuestion,
  (isQuestion) => isQuestion,
);

const getTokenSelector = createSelector(getToken, (token) => token);
const getLoginRecoverySelector = createSelector(getLogin, (login) => login);
const getIsEmailSelector = createSelector(getIsEmail, (isEmail) => isEmail);
const getIsPhoneSelector = createSelector(getIsPhone, (isPhone) => isPhone);
const getIsLoadingQuestionSelector = createSelector(
  getIsLoadingQuestion,
  (isLoadingQuestion) => isLoadingQuestion,
);

const getQuestionSecretSelector = createSelector(
  getQuestionState,
  (questionSecret) => questionSecret,
);

const getPasswordCurrentRecoveryStepNameSelector = createSelector(
  getPasswordCurrentRecoveryStepName,
  (currentPasswordRecoveryStepName: string) => currentPasswordRecoveryStepName,
);
const getIsLoadingSelector = createSelector(
  getIsLoadingPassCov,
  (isLoadingPassRecov) => isLoadingPassRecov,
);

const getLoginCurrentRecoveryStepNameSelector = createSelector(
  getLoginCurrentRecoveryStepName,
  (currentLoginRecoveryStepName) => currentLoginRecoveryStepName,
);
const getIsLoadingLoginRecoverySelector = createSelector(
  getIsLoadingLoginRecovery,
  (isLoadingLoginRecovery) => isLoadingLoginRecovery,
);
const getErrorLoginRecoverySelector = createSelector(
  getErrorMessageLogin,
  (errorMessageLoginRecovery) => errorMessageLoginRecovery,
);
const getIsLoadingChangePasswordSelector = createSelector(
  getIsLoadingChangePassword,
  (isLoadingChangePassword) => isLoadingChangePassword,
);

const getIsLoadingChangeSecretQuestionSelector = createSelector(
  getIsLoadingChangeSecretQuestion,
  (isLoadingChangeSecretQuestion) => isLoadingChangeSecretQuestion,
);

export {
  getQuestionSecretSelector,
  getIsLoadingQuestionSelector,
  getPasswordCurrentRecoveryStepNameSelector,
  getIsLoadingSelector,
  getLoginCurrentRecoveryStepNameSelector,
  getLoginRecoverySelector,
  getIsLoadingLoginRecoverySelector,
  getHashedEmailSelector,
  getHashedPhoneSelector,
  getIsEmailSelector,
  getIsPhoneSelector,
  getIsQuestionSelector,
  getErrorMessageSelector,
  getTokenSelector,
  getErrorLoginRecoverySelector,
  getIsLoadingChangePasswordSelector,
  getIsLoadingChangeSecretQuestionSelector,
  getIsLoadingNotficationEnabled,
};
